import * as ActionType from '../../constants/actionType';

const initialState = {
  colorPalette: [],
};

export default function colorState(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_COLOR_PALETTE:
      return {
        ...state,
        colorPalette: action.data,
      };
    default:
      return state;
  }
}
